import styled from '@emotion/styled'
import { Stack } from 'components/Stack'
import { pxToRem, BREAKPOINTS } from 'utils/styled'

export const SContainer = styled(Stack)`
  background: var(--c-blue50);
  padding: ${pxToRem(77)}rem;
  align-items: center;
  text-align: center;

  @media ${BREAKPOINTS.MD.max} {
    padding: ${pxToRem(42)}rem 5vw;
  }
`
